// Shared "Mission Deck" design tokens — a NASA-flight-ops palette widened to
// include the violet/coral tones from the painterly source art, with amber
// still the dominant accent and deep indigo/black grounding the whole system.
export const colors = {
  bgDeep: '#05070d',
  bgPanel: '#0a0e1a',
  bgPanelAlt: '#0c1120',
  hairline: 'rgba(143, 216, 255, 0.18)',
  hairlineStrong: 'rgba(143, 216, 255, 0.35)',
  amber: '#f2a93b',
  amberDim: 'rgba(242, 169, 59, 0.35)',
  cyan: '#8fd8ff',
  cyanDim: 'rgba(143, 216, 255, 0.35)',
  // widened palette pulled from the source paintings
  coral: '#ff8a5b',
  coralDim: 'rgba(255, 138, 91, 0.35)',
  violet: '#a78bfa',
  violetDim: 'rgba(167, 139, 250, 0.32)',
  textPrimary: '#eef2f7',
  textDim: 'rgba(238, 242, 247, 0.65)',
  textFaint: 'rgba(238, 242, 247, 0.4)',
  ok: '#7be0a8',
};

export const fonts = {
  display: "'Orbitron', sans-serif",
  mono: "'JetBrains Mono', 'Space Mono', monospace",
};
